import { Claims } from '../utils/services/cache/ClientCache'
const axios = require('axios');

export const getLearningContentCategories = async () => {
    return await axios({
        method: 'get',
        url: `${process.env.WEB_API}LearningContent/GetLearningContentCategories/${Claims.getGivenName()}`,
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            return response.data
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const GetLearningContentsByTraitGroupId = async (learningContentCategoryId) => {
    return await axios({
        method: 'get',
        url: `${process.env.WEB_API}LearningContent/GetLearningContentsByTraitGroupId/${learningContentCategoryId}/${Claims.getGivenName()}`,
        headers: {
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            return response.data
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const GetNonTraitLearningContents = async () => {
    return await axios({
        method: 'get',
        url: `${process.env.WEB_API}LearningContent/GetNonTraitLearningContents/${Claims.getGivenName()}`,
        headers: {
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            return response.data
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const GetLearningContentByLearningContentId = async (learningContentId) => {
    return await axios({
        method: 'get',
        url: `${process.env.WEB_API}LearningContent/GetLearningContentByLearningContentId/${learningContentId}`,
        headers: {
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            // return DecryptAES(response.data, key, iv);
            return response.data
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const GetAssessmentsByLearningContentId = async (learningContentId) => {
    return await axios({
        method: 'get',
        url: `${process.env.WEB_API}LearningContent/GetAssessmentsByLearningContentId/${learningContentId}`,
        headers: {
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const postAssessment = async (bodyFormData) => {
    return await axios({
        method: 'post',
        url: `${process.env.WEB_API}LearningContentAssessment/SubmitAssessmentAnswer`,
        data: bodyFormData,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            return response.data
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const postAssessmentNR = async (bodyFormData) => {
    return await axios({
        method:'post',
        url : `${process.env.WEB_API}LearningContentAssessment/SubmitAssessmentAnswerNR`,
        data : bodyFormData,
        headers : {
            'Content-Type' : 'application/json',
            'Authorization' : `Bearer ${Claims.getToken()}`
        }
    }).then(function (response) {
        console.log(response.data);
        return response.data;
    })
    .catch(function (error) {
        //handle error
        console.error(error);
        return error.response.status;
    });
}

export const SubmitNoAssessmentLearningContent = async (bodyFormData) => {
    return await axios({
        method: 'post',
        url: `${process.env.WEB_API}LearningContentAssessment/SubmitNoAssessmentLearningContent`,
        data: bodyFormData,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            return response.data
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const GetListEmojis = async () => {

    return await axios({
        method: 'get',
        url: `${process.env.WEB_API}LearningContent/GetListEmojis`,
        headers: {
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const updateViewedLearningContent = async (traitGroupId, learningContentId, studentNumber) => {
    return await axios({
        method: 'post',
        url: `${process.env.WEB_API}LearningContent/UpdateViewedLearningContent`,
        headers: {
            'Authorization': `Bearer ${Claims.getToken()}`
        },
        data: {
            TraitGroupId: traitGroupId,
            LearningContentId: learningContentId,
            StudentNumber: studentNumber,
        }
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const SubmitLearningContentEmoji = async (bodyFormData) => {
    return await axios({
        method: 'post',
        url: `${process.env.WEB_API}LearningContent/SubmitLearningContentEmoji`,
        data: bodyFormData,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const GetSpecialLearningContentById = async (learningContentId) => {
    return await axios({
        method: 'get',
        url: `${process.env.WEB_API}LearningContent/GetSpecialLearningContentById/${learningContentId}/${Claims.getGivenName()}`,
        headers: {
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const UpdatSelectedMaxLevelAsset = async (traitGroupId, studentNumber, selectedItemName) => {
    return await axios({
        method: 'post',
        url: `${process.env.WEB_API}LearningContentAssessment/UpdatSelectedMaxLevelAsset`,
        headers: {
            'Authorization': `Bearer ${Claims.getToken()}`
        },
        data: {
            StudentNumber: studentNumber,
            SelectedItemName: selectedItemName,
            TraitGroupId: traitGroupId,
        }
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};